import React, { useState } from 'react'
import { Stack, Typography } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import createDialogTitle from '../../generic/utilities/dialogUtil'
import SmartSelect from '../../generic/smartSelect/SmartSelect'
import SmartTextField from '../../generic/smarttextfield/SmartTextField'
import { updateDocumentRepositoryCard } from './documentRepositoryApi'

/**
 * DocumentRepositoryCardDialog — historia 170, HU-03 (J3, CU6). R7: edits ONLY name/type/description
 * (RN22 — never the file nor the order, DG-17: the card belongs to the DOCUMENT, so the change shows
 * in every one of its associations). `associationCount > 1` warns how many records that is (RN22b,
 * G2-1, S79); `associationCount === 1` shows no warning (S176). An empty name blocks the send (V9,
 * S80) — same rule as the module's own form.
 */
const DocumentRepositoryCardDialog = ({ row, documentTypes, onClose, onSaved, onError }) => {
  const { t_ } = useSmartTranslation()
  const [documentName, setDocumentName] = useState(row.documentName || '')
  const [documentTypeId, setDocumentTypeId] = useState(row.documentType ? row.documentType.id : '')
  const [description, setDescription] = useState(row.description || '')

  const handleAccept = async () => {
    if (documentName.trim() === '') return
    try {
      // documentTypeId travels as '' here (never null/undefined, CLAUDE.md) — documentRepositoryApi.js
      // is the only place that translates it to null, same convention as the R2 criteria.
      await updateDocumentRepositoryCard(row.topic, row.referenceId, row.documentId, {
        documentName,
        documentTypeId,
        description
      })
      onSaved()
    } catch (error) {
      onError(error && error.message ? error.message : '')
    }
  }

  return (
    <SmartDialog
      setOpen
      title={createDialogTitle({ title: t_('Edit') })}
      renderComponent={(
        <Stack spacing={2} sx={{ minWidth: '20rem' }}>
          {row.associationCount > 1 && (
            <Typography color='warning.main'>{t_('This change will affect {{count}} records', { count: row.associationCount })}</Typography>
          )}
          <SmartTextField
            label={t_('Document name')}
            value={documentName}
            onChange={setDocumentName}
          />
          <SmartSelect
            label={t_('Document type')}
            autoSelectFirst={false}
            selectableOptions={documentTypes.map((type) => String(type.id))}
            value={documentTypeId === '' ? null : String(documentTypeId)}
            optionLabelTransform={(idString) => (documentTypes.find((type) => String(type.id) === idString) || {}).name || idString}
            onChange={(idString) => setDocumentTypeId(idString ? Number(idString) : '')}
          />
          <SmartTextField
            label={t_('Description')}
            value={description}
            onChange={setDescription}
            multiline
          />
        </Stack>
      )}
      disableAccept={documentName.trim() === ''}
      acceptCallback={handleAccept}
      cancelCallback={onClose}
      closeCallback={onClose}
    />
  )
}

export default DocumentRepositoryCardDialog
